export enum AddReferralStatuses {
  INVITED = 'successful',
  WHATSAPP_READY = 'whatsapp_ready',
  PENDING_APPROVAL = 'pending_approval',
  INVALIDPHONE = 'invalidPhone',
  ALREADYREGISTERED = 'alreadyRegistered',
  INVITATION_ALREADY_SENT = 'invitation_already_sent'
}
